export default __webpack_public_path__ + "static/media/wind_oli.168f7e9c.svg";